import { TravelDocumentSalesModel } from 'api-hooks/sale/travel-document';
import Popover from 'components/popover';
import useRevertDraftAction from 'hooks/use-revert-draft-action';
import useSalesEditAction from 'legacy-modules/sales/hooks/use-sales-edit-action';
import useSalesStatus from 'legacy-modules/sales/hooks/use-sales-status';

import { DocumentSaleFormType } from './form-type';
import useDocumentSaleActions from '../hooks/use-document-sale-actions';

interface ActionComponentProps {
  data: TravelDocumentSalesModel;
  defaultValues: DocumentSaleFormType;
}

export default function ActionComponent(props: ActionComponentProps) {
  const type = 'document-sales';
  const { saleStatus } = useSalesStatus(props.data);
  const { editAction } = useSalesEditAction(props.data, type);
  const {
    completeComponent,
    incompleteComponent,
    requestApprovalButton,
    resolverButton,
    updateNextDocumentComponent,
    requestApprovalRevertDraftButton,
    ...rest
  } = useDocumentSaleActions({
    data: props.data,
    defaultValues: props.defaultValues,
  });
  const { revertDraftButton } = useRevertDraftAction(
    'document-sales',
    props.data,
  );
  const actions = [editAction, ...rest.actions].filter(
    (action) => action.isAllowed,
  );

  if (saleStatus.isHideActionComponent) {
    return null;
  }
  return (
    <div
      style={{
        display: 'flex',
        gap: 16,
      }}
    >
      {revertDraftButton}
      {requestApprovalButton}
      {requestApprovalRevertDraftButton}
      <Popover actions={actions} />
      {updateNextDocumentComponent}
      {resolverButton}
      {incompleteComponent}
      {completeComponent}
    </div>
  );
}
